<template>
  <div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          订单分类<span v-if="required" class="required">*</span>：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="contractType">
            <el-select ref="contractType" v-model="form.contractType" placeholder="请选择订单分类" style="width:100%;" @change="change">
              <el-option v-for="option in allList" :key="option.name" :value="option.code" :label="option.name " />
            </el-select>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { mapState, mapActions } from 'vuex';
export default {
  data () {
    return {
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  computed: {
    ...mapState({
      orderType: state => state.enumeration.orderType
    }),
    allList () {
      return this.orderType.filter((item) => {
        return item.name !== '国际业务下单';
      });
    }
  },
  methods: {
    ...mapActions('enumeration', [
      'initOrderType'
    ]),
    initData () {
      if (this.form.contractTypeCode) {
        // this.OrderType = this.form.supplyAddress;
      }
    },
    change (val) {
      this.$nextTick(() => {
        // this.form.contractType = this.$refs.contractType.selectedLabel;
        this.$emit('changeOrderState', val);
      });
    }
  },
  mounted () {
    this.initOrderType();
    this.initData();
  }
};
</script>
